// SR-2023: Temporarily disable signature functionality
export default defineNuxtRouteMiddleware(() => {
  return navigateTo('/invoices');
});
